export default function HeroSection() {
  const handleScroll = (href: string) => {
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section className="relative min-h-screen flex flex-col justify-center overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/6647e925b155740807c32e3970900c30.jpg"
          alt="Hero Background"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/30 to-black/60" />
      </div>

      {/* Decorative large text */}
      <div className="absolute bottom-0 left-0 right-0 overflow-hidden pointer-events-none select-none">
        <p
          className="text-white/8 font-black leading-none whitespace-nowrap"
          style={{ fontSize: "clamp(60px, 10vw, 140px)", fontFamily: "'Noto Serif TC', serif" }}
        >
          讓每一次相遇都成為生命中的驚喜
        </p>
      </div>

      {/* Content */}
      <div className="relative z-10 w-full max-w-7xl mx-auto px-4 md:px-8 pt-24 pb-32">
        <div className="max-w-3xl">
          {/* Logo */}
          <div className="flex items-center gap-4 mb-8">
            <img
              src="https://public.readdy.ai/ai/img_res/2de05ae8-ab7f-40ca-afb5-96f93dc606a2.png"
              alt="Rappy me Logo"
              className="h-16 w-16 md:h-20 md:w-20 object-contain drop-shadow-lg"
            />
            <div className="inline-flex items-center gap-2 bg-white/15 backdrop-blur-sm border border-white/25 rounded-full px-4 py-1.5">
              <span className="w-2 h-2 rounded-full bg-red-400 animate-pulse" />
              <span className="text-white/90 text-sm font-medium">台灣最溫暖的生活策劃平台</span>
            </div>
          </div>

          {/* Main Title */}
          <h1
            className="text-white font-black leading-tight mb-6"
            style={{
              fontSize: "clamp(40px, 6vw, 80px)",
              fontFamily: "'Noto Serif TC', serif",
              lineHeight: 1.2,
            }}
          >
            放下手機藍光
            <br />
            來擁抱營火紅光
            <br />
            <span className="text-red-400">你的紅歡密時刻</span>
          </h1>

          {/* Subtitle */}
          <p className="text-white/75 text-lg md:text-xl mb-10 max-w-xl leading-relaxed">
            「紅」是熱情，「歡」是共享，「密」是深度。
            <br />
            讓我們陪你，把每一天都過成想望中的樣子。
          </p>

          {/* CTA Buttons */}
          <div className="flex flex-col sm:flex-row gap-4">
            <button
              onClick={() => handleScroll("#upcoming-events")}
              className="px-8 py-3.5 rounded-full bg-red-600 text-white font-semibold text-base hover:bg-red-700 transition-all duration-200 cursor-pointer whitespace-nowrap flex items-center justify-center gap-2"
            >
              <i className="ri-calendar-event-line" />
              探索近期活動
            </button>
            <button
              onClick={() => handleScroll("#wish-pool")}
              className="px-8 py-3.5 rounded-full border-2 border-white/70 text-white font-semibold text-base hover:bg-white/15 transition-all duration-200 cursor-pointer whitespace-nowrap flex items-center justify-center gap-2"
            >
              <i className="ri-star-line" />
              許願池
            </button>
          </div>
        </div>

        {/* Stats Row */}
        <div className="mt-16 flex flex-wrap gap-8 md:gap-16">
          {[
            { num: "500+", label: "場活動完美落幕" },
            { num: "8,000+", label: "位夥伴找到歸屬" },
            { num: "95%", label: "回購率與好評推薦" },
          ].map((stat) => (
            <div key={stat.label} className="text-white">
              <div
                className="font-black text-3xl md:text-4xl text-red-400"
                style={{ fontFamily: "'Noto Serif TC', serif" }}
              >
                {stat.num}
              </div>
              <div className="text-white/70 text-sm mt-1">{stat.label}</div>
            </div>
          ))}
        </div>
      </div>

      {/* Scroll indicator */}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 flex flex-col items-center gap-2 animate-bounce">
        <span className="text-white/50 text-xs">向下探索</span>
        <i className="ri-arrow-down-line text-white/50 text-lg" />
      </div>
    </section>
  );
}
